'use client';

import { useUserLogged } from '@/hooks/useUserLogged';
import { useAgentInsightsOnboardingStatus } from '@/hooks/useTeamInsightsOverview';

/**
 * Warms the Agent Insights onboarding latch as the first request in the
 * home subtree, so `agentDataState.ts`'s own read of the same hook (gating
 * `ModelBurnSection` / `PlatformActivitySection`'s overview-bundle fetch)
 * resolves from cache instead of a fresh round-trip. Mirrors the Agent
 * Insights and Model Router prefetches — this route was the one left
 * without it. Renders nothing.
 *
 * `orgUuid` must resolve exactly like `agentDataState.ts`'s own
 * `useAgentDataState` does (`user?.OrganizationUUID` before
 * `organization?.OrgUUID`, not the other way around as the Model Router
 * version has it) — a different priority order here would warm a
 * different org's cache entry and this prefetch would miss its target.
 */
export function OnboardingLatchPrefetch() {
  const { organization, user } = useUserLogged();
  const orgUuid = user?.OrganizationUUID || organization?.OrgUUID || '';
  useAgentInsightsOnboardingStatus(orgUuid);
  return null;
}
